<template>
  <div></div>
</template>

<script>
  export default {
    beforeRouteEnter(to, from, next) {
      next(vm => {
        console.log(to);
        vm.$router.replace({
          path: from.path+'?tid='+to.query.tid,
        })
      })
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/refresh.vue